import { render, staticRenderFns } from "./PgLogin.vue?vue&type=template&id=6d592132&scoped=true&"
import script from "./PgLogin.vue?vue&type=script&lang=js&"
export * from "./PgLogin.vue?vue&type=script&lang=js&"
import style0 from "./PgLogin.vue?vue&type=style&index=0&id=6d592132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d592132",
  null
  
)

/* custom blocks */
import block0 from "@/components/functions/Auth/locales/en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fhtml%2Facc-web%2Fadmin%2Fsrc%2Fcomponents%2Ffunctions%2FAuth%2FPgLogin.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/functions/Auth/locales/zhHant.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fhtml%2Facc-web%2Fadmin%2Fsrc%2Fcomponents%2Ffunctions%2FAuth%2FPgLogin.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VProgressLinear,VRow,VTextField})
